(() => {
  const init = () => {
    const stickyBar = document.querySelector('.m-sticky-addtocart');
    const footer = document.querySelector('footer, .m-footer');

    if (!stickyBar || !footer || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('habanerisima-sticky-hidden', entry.isIntersecting);
      },
      { threshold: 0.02 }
    );

    observer.observe(footer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
